import React from 'react';
import { render, hydrate, unmountComponentAtNode } from 'react-dom';
import { Provider } from 'react-redux';
import { AppContainer } from 'react-hot-loader';
import { RudyProvider } from '@respond-framework/react';

import { Store, rudyApi } from '../../ReduxStorage/Store';
import { ErrorThrower } from './ErrorThrower/index';

// import { mountTarget, unmountTarget } from '../../components/mountable';

export const mountTarget = (
  component,
  target,
  props = {},
  { ssr = false } = {}
) => {
  // https://medium.com/@TranscendMikey/react-gotcha-dynamically-rendering-components-with-jsx-b53fc07f63ca
  /* eslint-disable react/jsx-pascal-case */
  const $component = component;

  (ssr ? hydrate : render)(
    <AppContainer errorReporter={ErrorThrower}>
      <Provider store={Store}>
        <RudyProvider api={rudyApi}>
          <$component {...props} />
        </RudyProvider>
      </Provider>
    </AppContainer>,
    target
  );
};

export const unmountTarget = (target) => {
  // This will trigger componentWillUnmount()
  unmountComponentAtNode(target);
};
